import React, { useEffect, useState } from 'react'
import { Header } from '../Core/Header'
import { Footer } from '../Core/Footer'
import "../../Styles/service.css"
import { getOrderHistory, serviceAdd } from '../Services/Operations/ProductAPI'
import { toast } from 'react-toastify'

const Service = () => {
 
  const[selectedProduct,setSelectedProduct]=useState(null)
  const [orderList,setOrderList]=useState([])
  const [file,setFile]=useState([])
  const[modalOpen,setModalOpen]=useState(false)
  const [lodes,setLodes]=useState(false)
  const[pickUpTime,setPickupTime]=useState(null)
  const[pickupLocation,setPickupLocation]=useState("")
  const[phNumber,setPhNumber]=useState("")
  const[serialNumber,setSerialNumber]=useState("")

  const[mobile,setMobile]=useState(window.innerWidth<567)

 const fetchOrderHistory=async()=>{
  try {
    const response=await getOrderHistory()
    console.log(response);
    if(response.status===200){
      const uniquesProducts= await extractUniqueProducts(response.data)
      console.log(uniquesProducts);
      setOrderList(uniquesProducts)
      
      return
    }
    
  } catch (error) {
    console.log(error);
    
  }
 }


 // the below function performs a complex task , it extract the data from each order list and make a list of all products such a way to no repeatation

 const extractUniqueProducts =async (orders) => {
  const productMap = new Map();

  orders.forEach(order => {
    order.items?.forEach(item => {
      if (productMap.has(item.productId)) {
        const existing = productMap.get(item.productId);
        // Merge and deduplicate keys
        existing.serialNumbersWithEar = Array.from(new Set([...existing.serialNumbersWithEar, ...item.serialNumbersWithEar]));
      } else {
        // Clone the product to prevent mutating the original item
        productMap.set(item.productId, { ...item, keys: [...item.serialNumbersWithEar] });
      }
    });
  });

  return Array.from(productMap.values());
};

const serviceAddHandler=async(e)=>{
  e.preventDefault()
  if(!selectedProduct||!serialNumber||!pickupLocation||!phNumber||!file||!pickUpTime){
    toast.error('Please fill all the fields')
    return
  }
  try {
    setLodes(true)

const formData = new FormData();

const localDateTime = pickUpTime.toISOString().slice(0, 16);
console.log("localDateTime : ",localDateTime)
formData.append(
  'data',
  new Blob([JSON.stringify({
    pickupDateTime: localDateTime,
    productId: selectedProduct.productId,
    serialNumber: serialNumber,
    pickupLocation: pickupLocation,
    alternateNumber: phNumber
  })], { type: 'application/json' })
);

// Append files
for (let img of file) {
  formData.append("productImageFiles", img);
}

// Append image type
formData.append("productImageType", "BOOKING");

    const response=await serviceAdd(formData)


    console.log("serviceAdd:",response);
    if(response.status===200){
      toast.success('Service booked sucessfully')
    }

    
    
  } catch (error) {
    toast.error('Failed to submit')
    console.log(error);
    
  }finally{
    setLodes(false)
    setSelectedProduct(null);
    setSerialNumber("");
    setPickupLocation("");
    setPhNumber("");
    setFile([]);
    setPickupTime(null)
    setModalOpen(false)
  }
}

const modalController=(id)=>{

const item=  orderList.find((item)=>item.id===id)

  setSelectedProduct(item);
  setModalOpen(true)

//setCodes(item.uniqueCodes)

}

const handleDateChange = (e) => {
    const rawValue = e.target.value; // format: "2025-07-28T23:13"
    const date = new Date(rawValue);

    // Convert to desired string format
    // const formatted = date.toString(); // "Mon Jul 28 2025 23:13:00 GMT+0530 (India Standard Time)"
    setPickupTime(date);
  };


 useEffect(() => {
   fetchOrderHistory()
 }, [])
 


  return (
    <div style={{}}>
        <Header/>
         <div className="enquiry-wrapper flex gap-2 ">

          <div className='serviceBar'>
            
           <div className='leftBlock' style={{background:'linear-gradient(to top, gray,white)'}}>

            <p style={{fontWeight:"600",fontSize:"25px",borderLeft:"5px solid orange",paddingLeft:"10px"
            }}>Order History</p>
             <div className='orderList' style={{position:"relative",display:"flex",flexWrap:"wrap",flexDirection:!mobile?"row":"column"}}>
              
            {
            
             orderList.map((item,index)=>
                <div key={item} style={{borderRight:"1px solid black",padding:"0.4rem",margin:"3px",borderBottom:"1px solid black",
                  borderRadius:"10px",backgroundColor:"#d6d6d6",cursor:"pointer",width:"8rem", transition: "transform 0.3s ease-in-out"}}
                onClick={()=>modalController(item.id)}

                     onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.05)")}
           onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
                >
                    <img src={`https://rndsan.com/api${item.productImage}`} style={{width:"100%",borderRadius:"10px"}} />
                 
                  
                  <p style={{fontWeight:"bold",fontSize:"16px"}}> {item.productName} </p>
                  <p style={{fontWeight:"bold",fontSize:"12px"}}>Price :{item.salePrice}</p>
                   <p style={{fontWeight:"400",fontSize:"8px"}}>Available Serial numbers :{item.serialNumbersWithEar.length}</p>
                  {/* <p>Order pieces:{item.uniqueCodes.length}</p> */}
                </div>
              )
             
            }  </div>

            {modalOpen?<div 
            style={{zIndex:999, background: "linear-gradient(to bottom, #fde1dbff, #555555ff)",padding:"12px",borderRadius:"10px",top:"20vh",position:"absolute",width:mobile?"60%":"30%"}}>
             
              <p style={{fontSize:"20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                Select a serial number:  <span onClick={()=>setModalOpen(false)} style={{cursor:"pointer"}}>X</span></p>
                <div style={{maxHeight:"50vh",overflowY:"auto"}}>
              {
                selectedProduct?.serialNumbersWithEar?.length>0 ?
                selectedProduct.serialNumbersWithEar.map(i=>(
                  <p onClick={()=>{serialNumber!==i.serialNumber?setSerialNumber(i.serialNumber):setSerialNumber("")}}
                  style={{padding:"8px",cursor:"pointer",backgroundColor:"white",display:"flex",justifyContent:"space-between",borderRadius:"10px"}}>
                    <span style={{fontWeight:"bold"}}>{i.serialNumber}</span>
                    <span>{i.ear}</span>
                  {serialNumber!==i.serialNumber?
                    <span  style={{backgroundColor:"white",color:"white",padding:"5px",borderRadius:"10px",cursor:"pointer"}}>⭕</span>
                  :
                    <span  style={{backgroundColor:"gray",color:"black",padding:"5px",borderRadius:"10px",cursor:"pointer"}}>✅</span>}
                    </p>
                ))
                :
                <p>Unique Codes are not available</p>
              }</div>
            </div>:""}
            
           

           </div>

              {
                window.innerWidth>720?
                <div className='rightBlock'>

         <div style={{display:"flex",alignItems:"center",flexDirection:"column"}}>

          <p style={{fontSize:"25px",fontWeight:"600",borderLeft:"5px solid orange",paddingLeft:"8px"}}>Select a product from ordered history</p>
          {
            !selectedProduct?
            <p style={{padding:"8px",color:"red", borderRadius:"5px",border:"1px solid black"}}>No product is selected to send for servicing</p>
            :

            <p style={{padding:"8px",color:"green", borderRadius:"5px",border:"1px solid black"}}>Selected product :{selectedProduct?.productName}{"    "}
             <span style={{cursor:"pointer"}} onClick={()=>{setSelectedProduct(""); setSerialNumber("")}}>❌</span></p>
          }

           <div style={{width:"100%",display:"flex", paddingLeft:"30px"}}>
            
            <form onSubmit={serviceAddHandler}
            style={{width:"70%", margin:"10px", display:"flex",flexDirection:"column",padding:"10px"}}>
             <p style={{padding:"5px",borderRadius:"10px",backgroundColor:"gray",color:"white"}}>{serialNumber?serialNumber:"Select a product"}</p>
             <label style={{color:"black"}}>Select Pickup Time</label>
              <input style={{height:"15px"}} placeholder='Enter pick up date time'
              type="datetime-local" onChange={handleDateChange}/>
              
              <input style={{height:"15px"}} placeholder='Enter pick up location'
              value={pickupLocation} onChange={(e)=>setPickupLocation(e.target.value)}/>
              
              <input style={{height:"15px"}} placeholder='Enter an alternatine ph number'
              value={phNumber} onChange={(e)=>setPhNumber(e.target.value)}/>
              
            
               <label>Chhose Image</label>
              <input type='file'  onChange={(e)=>setFile(item=>[...item,e.target.files[0]])} style={{height:"50px",width:"200px",fontSize:"15px"}}/>
            
            { lodes?<button  style={{height:"100%",cursor:"not-allowed"}}>processing..</button>
            :
             <button  style={{height:"100%"}}>submit</button>}
              </form>
             
           
          <div style={{width:"30%",display:"flex",justifyContent:"center",alignItems:"center"}}>
            <div style={{width:"80%",border:"1px solid skyblue",padding:"20px",borderRadius:"10px",display:"flex"}}>
              {file.length>0?<img src={URL.createObjectURL(file[0])}/>
              :<img src='/Assets/img/preview.jpg'/>
            }
          
            <p style={{position:"absolute",borderRadius:"50%",backgroundColor:"white",padding:"5px",cursor:"pointer"}}
            onClick={()=>setFile([])}
            >X</p>
            </div>
              {file.length>0? <div style={{display:"flex"}}>
               {file.map((img,ind)=> <img src={URL.createObjectURL(file[ind])} style={{width:"35px",height:"35px"}}/>)}
                </div>:""}
          </div>


          </div>

         </div>
         
            </div>
            :
            <div className='rightBlock1'>

         <div style={{display:"flex",alignItems:"center",flexDirection:"column"}}>

          <p style={{fontSize:"25px",fontWeight:"600"}}>Select a product from ordered history</p>
          {
            !selectedProduct?
            <p style={{padding:"8px",color:"red", borderRadius:"5px",border:"1px solid black"}}>No product is selected to send for servicing</p>
            :

            <p style={{padding:"8px",color:"green", borderRadius:"5px",border:"1px solid black"}}>Selected product :{selectedProduct?.productName}{"    "}
             <span style={{cursor:"pointer"}} onClick={()=>{setSelectedProduct(""); setSerialNumber("")}}>❌</span></p>
          }

           <div style={{width:"100%",display:"flex"}}>
            
            <form onSubmit={serviceAddHandler}
            style={{width:"50%", margin:"1px", display:"flex",flexDirection:"column"}}>
             <p style={{padding:"5px",borderRadius:"10px",backgroundColor:"gray",color:"white"}}>{serialNumber?serialNumber:"Select a product"}</p>
             <label style={{color:"black"}}>Select Pickup Time</label>
              <input style={{height:"15px"}} placeholder='Enter pick up date time'
              type="datetime-local" onChange={handleDateChange}/>
              
              <input style={{height:"15px"}} placeholder='Enter pick up location'
              value={pickupLocation} onChange={(e)=>setPickupLocation(e.target.value)}/>
              
              <input style={{height:"15px"}} placeholder='Enter an alternatine ph number'
              value={phNumber} onChange={(e)=>setPhNumber(e.target.value)}/>
              
            
               <label>Chhose Image</label>
              <input type='file'  onChange={(e)=>setFile(item=>[...item,e.target.files[0]])} style={{height:"50px",width:"200px",fontSize:"15px"}}/>
            
            { lodes?<button  style={{height:"100%",cursor:"not-allowed"}}>processing..</button>
            :
             <button  style={{height:"100%"}}>submit</button>}
              </form>
             
           
          <div>
            <div style={{width:"100%",border:"1px solid skyblue",padding:"20px",borderRadius:"10px",display:"flex"}}>
              {file.length>0?<img src={URL.createObjectURL(file[0])}/>
              :<img src='/Assets/img/preview.jpg'/>
            }
          
            <p style={{position:"absolute",borderRadius:"50%",backgroundColor:"white",padding:"5px"}}
            onClick={()=>setFile([])}
            >X</p>
            </div>
              {file.length>0? <div style={{display:"flex"}}>
               {file.map((img,ind)=> <img src={URL.createObjectURL(file[ind])} style={{width:"35px",height:"35px"}}/>)}
                </div>:""}
                </div>
          </div>

         </div>
         
            </div>
              }
           
            </div>
         </div>

        <Footer/>
    </div>
  )
}

export default Service